import React from "react";
import { UIFooter } from "../../../UI/UIHomePage/UIFooter/UIFooter";

export const FooterSection = () => {
  return <UIFooter />;
};
